<template>
    <console-content max-width="1280">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">CP 관리</v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch"> <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터 </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold pb-0">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.hidesOnList" label="노출여부" placeholder=" " hide-details :items="items_hidesOnList" item-text="text" item-value="value" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field
                                v-model="filter.searchValue"
                                label="검색어"
                                placeholder=" "
                                hide-details
                                :disabled="!filter.searchKey"
                                @keydown.enter="
                                    page = 1;
                                    search(true);
                                "
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        rounded
                        text
                        @click="
                            page = 1;
                            search(true);
                        "
                    >
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon
                    >엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :items="cps" :headers="partnersHeaders" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                <v-icon small class="ml-1" @click="remove(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.hidesOnList="{ item }">
                <v-switch v-model="item.hidesOnList" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="(hidesOnList) => update({ _id: item._id, hidesOnList })" />
            </template>
            <template v-slot:item.cash="{ item }">
                <div>{{ item?.cash?.format?.() }} <v-icon size="20" right @click="charge(item)">mdi-plus-circle-multiple-outline</v-icon></div>
            </template>
            <template v-slot:item.dailyAmount="{ item }">
                {{ calculateSum(item, "daily")?.format?.() }}
            </template>
            <template v-slot:item.monthlyAmount="{ item }">
                {{ calculateSum(item, "monthly")?.format?.() }}
            </template>
            <template v-slot:item.createdAt="{ item }">
                {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />

        <v-btn color="pink" fab fixed bottom right dark @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

        <cp-cash-dialog ref="cp-cash-dialog" @save="search"></cp-cash-dialog>
    </console-content>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import { mdiMicrosoftExcel } from "@mdi/js";
import cpCashDialog from "@/components/console/cp/cp-cash-dialog.vue";

export default {
    components: {
        ConsoleContent,
        cpCashDialog,
    },
    data() {
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                hidesOnList: false,
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "업체명", value: "companyName" },
            ],

            items_hidesOnList: [
                { text: ":: 전체 ::", value: null },
                { text: "노출", value: false },
                { text: "미노출", value: true },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            cps: [],
            partnersHeaders: [
                { text: "업체명", value: "name", align: "center", width: 200 },
                { text: "연락처", value: "phone", align: "center" },
                { text: "이메일", value: "email", align: "center" },
                { text: "노출 / 미노출", align: "center", value: "hidesOnList", width: 100 },
                { text: "금일구매금액", value: "dailyAmount", align: "center", width: 160 },
                { text: "금월구매금액", value: "monthlyAmount", align: "center", width: 160 },
                { text: "캐시잔액", value: "cash", align: "end", width: 160 },
                { text: "생성일자", value: "createdAt", align: "center", width: 110 },
                { text: "actions", value: "actions", align: "center", width: 80 },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },

        async search(routable = false) {
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, cps } = await api.console.cps.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.cps = cps;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        create() {
            this.$router.push(`/console/cps/create`);
        },

        edit(cp) {
            this.$router.push(`/console/cps/${cp._id}`);
        },

        charge(cp) {
            this.$refs["cp-cash-dialog"].cp = cp;
            this.$refs["cp-cash-dialog"].open();
        },

        async update(data) {
            await api.console.cps.put(data);
        },

        async remove(cp) {
            if (confirm("정말 삭제하시겠습니까?")) {
                await api.console.cps.delete(cp);
                alert("삭제되었습니다");
                this.search();
            }
        },

        calculateSum(cp, type) {
            const purchases = cp?.riskManagement?.giftcard?.purchases || {};
            if (type === "daily") {
                let today = this.$dayjs().format("YYYY-MM-DD");
                return Object.entries(purchases || {}).reduce((dailyAmount, [date, amount]) => (date === today ? dailyAmount + amount : dailyAmount), 0);
            }

            if (type === "monthly") {
                let month = this.$dayjs().format("YYYY-MM");
                return Object.entries(purchases || {}).reduce((monthlyAmount, [date, amount]) => (date.substr(0, 7) === month ? monthlyAmount + amount : monthlyAmount), 0);
            }

            return 0;
        },

        async excel() {
            let { cps } = await api.console.cps.gets({
                headers: { limit: 0 },
                params: this.filter,
            });

            var datas = [];
            cps.forEach((cp) => {
                datas.push({
                    업체명: cp?.companyName,
                    아이디: cp?.username,
                    코드: cp?.code,
                    연락처: cp?.phone,
                    이메일: cp?.email,
                    생성일자: cp?.createdAt ? this.$dayjs(cp?.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "CP 목록");
            XLSX.writeFile(workbook, "CP 목록.xlsx");
        },
    },
};
</script>
